import React, { useEffect, useState } from 'react'

import SectionLayout from '../../components/reusable/SectionLayout'
import InsuranceCard from './InsuranceCard'
import fetchFarmerInsurance from '../../apis/fetchFarmerInsurance'
import {
  CLAIM_STATUS,
  Insurance,
  InsuranceTypeCounts,
} from '../../models/inusrance'
import EmptySectionCard from '../reusable/EmtySectionCard'

interface Props {
  farmerId: string
  highlight: boolean
}

const InsuranceSection = ({ farmerId, highlight }: Props) => {
  const [loading, setLoading] = useState(true)
  const [policies, setPolicies] = useState<Insurance[]>([])
  const [insuranceTypeCounts, setInsuranceTypeCounts] =
    useState<InsuranceTypeCounts>()

  const calculateClaimStatus = (policyEndDate: string) => {
    // Check claim status logic
    const parts = policyEndDate.split('/')
    const formattedDateString = `${parts[2]}-${parts[1]}-${parts[0]}`
    const date = new Date(formattedDateString)

    if (Date.now() < date.getTime()) {
      return CLAIM_STATUS.TO_BE_EVALUATED
    } else {
      return CLAIM_STATUS.UNDER_EVALUATION
    }
  }

  const fetchAndUpdateFarmerInsurance = async () => {
    const response = await fetchFarmerInsurance(farmerId)
    if (response?.results) {
      setPolicies(response.results)
      setInsuranceTypeCounts(response.insurance_type_counts)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchAndUpdateFarmerInsurance()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SectionLayout
      loading={loading}
      title="Insurance"
      description={
        insuranceTypeCounts && insuranceTypeCounts?.['CROP INSURANCE']
          ? `CROP INSURANCE: ${insuranceTypeCounts?.['CROP INSURANCE']}`
          : ''
      }
      highlight={highlight}
    >
      {policies.map(p => (
        <InsuranceCard
          key={p.enrollment_no}
          claimStatus={calculateClaimStatus(
            p.policy_order_details.group_insurance_product.policy_end_at,
          )}
          policyName={
            p.policy_order_details.group_insurance_product.insurance_type_name
          }
          enrollmentId={p.enrollment_no}
          policyStatus={p.policy_order_details.policy_status}
          coverType={
            p.policy_order_details.group_insurance_product.type_of_policy
          }
          sumInsured={p.sum_insured}
          premiumPaid={p.total_premium_amount}
          costToFarmer={p.cost_to_farmer}
          policyEndDate={
            p.policy_order_details.group_insurance_product.policy_end_at
          }
          policyStartDate={
            p.policy_order_details.group_insurance_product.policy_start_at
          }
        />
      ))}
      {policies.length === 0 && <EmptySectionCard title={'No record found.'} />}
    </SectionLayout>
  )
}

export default InsuranceSection
